
import { mmMatches } from '../utils/utils.matchmedia';

const 	$ = jQuery;

const 	$recipe_filter_toggle = $('.js-recipe-filter-toggle'),
		$recipe_filter_wrapper = $('.js-recipe-filter-wrapper');

let 	is_open = false;

if ( $recipe_filter_toggle.length ) {
	
	$recipe_filter_toggle.removeClass('no-js');

	$recipe_filter_toggle.on('click', function () {

		is_open = is_open == true ? false : true;

		$recipe_filter_wrapper.slideToggle();

		$recipe_filter_toggle.toggleClass('is-open');

	});

	if ( $recipe_filter_toggle.hasClass('is-closed-on-load-for-smaller-screens') && mmMatches( 'tablet-max' ) ) {
		$recipe_filter_toggle.click();
	}
}
